<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps } from 'vue';
import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import CampoTextareaBase from '@/components/v2/base/CampoTextareaBase/CampoTextareaBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({

    dado: {
        type: Object,
        default: () => ({})
    }

});

</script>

<template>

    <CartaoBase>

        <template #header>
            <span class="c-header__titulo">Justificativa de Emissão</span>
        </template>

        <template #body>

            <CampoTextareaBase
                label="Justificativa de Emissão"
                :value="props?.dado?.justificativa"
                disabled
            ></CampoTextareaBase>

        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Header ========================================*/
/*==================================================================*/

.c-header__titulo {
    font-size: 1.25rem;
    font-weight: 700;
}

</style>
